'use client'
import Image from 'next/image'
import Link from 'next/link'
import { useParams, useRouter, useSearchParams } from 'next/navigation'
import { useEffect } from 'react'

interface Category {
  image: string
  comp_id: string
  label: string
  type: string
}


export default function SidebarCategories({ items }: { items: Category[] }) {
  const params = useParams()
  const searchParams = useSearchParams()
  const router = useRouter()
  useEffect(() => {
    if (!params?.comp_id && items.length > 0) {
      router.push(`/categories/${items[0].type}?comp_id=${items[0].comp_id}`);
    }
  }, [params, items]);

  return (
    <aside className="w-20 bg-white border-r flex flex-col items-center gap-2 h-full overflow-y-auto">
      {items.map((cat) => (
        <Link href={`/categories/${cat.type}?comp_id=${cat.comp_id}`} key={cat.comp_id} className='w-full mb-2 relative'>
          {/* {searchParams.get('comp_id') === cat.comp_id && params?.comp_id==cat.type&&<div className="border-l-4 border-[#2563eb] absolute inset-y-0 left-0 w-1.5"></div>} */}
          <div
            key={cat.comp_id}
            className={`flex flex-col items-center w-full py-2 cursor-pointer}`}
          >
            <figure className="relative">
              {searchParams.get('comp_id') === cat.comp_id && params?.comp_id === cat.type && (
                <div
                  className="absolute inset-0 rounded-[12px] p-[1.5px]"
                  style={{
                    background: 'radial-gradient(227.4% 85.83% at 92.5% 14.17%, #FFFFFF 0%, #FFF1E6 57.78%, #6D401A 100%)'
                  }}
                >
                  <div className="w-full h-full rounded-[10.5px]" style={{
                    background: 'linear-gradient(360deg, #F8DCC4 0%, #FFFFFF 100%)'
                  }} />
                </div>
              )}
              <div className="relative z-1 p-1">
                <Image
                  src={cat.image?`${cat.image}?h=40`: process.env.NEXT_PUBLIC_UNKONWN_CATEGORIES?process.env.NEXT_PUBLIC_UNKONWN_CATEGORIES:""}
                  alt={cat.label}
                  width={40}
                  height={40}
                  className="rounded-[12px] transition-all h-[40px] w-[40px] object-cover"
                />
              </div>
            </figure>
            <span
              className={`text-[10px] text-center px-1 mt-1 ${searchParams.get('comp_id') === cat.comp_id && params?.comp_id === cat.type ? 'text-[#6F421D] font-semibold' : 'text-gray-500'}`}>
              {cat.label.length > 14
                ? cat.label.slice(0, 13) + '…'
                : cat.label}
            </span>
          </div>
        </Link>
      ))}
    </aside>
  )
}